
<div class="brick one"></div>
<div class="tooltip-mario-container">
  <div class="box"></div>
  <div class="mush"></div>
</div>
<div class="brick two"></div>
